import jwt from 'jsonwebtoken'

import { getValue } from './store'

declare global {
  interface Window {
    Intercom: any
    intercomSettings: any
  }
}

export const initializeIntercom = (): string => {
  if (!window.Intercom) {
    return
  }

  const token = getValue('idToken')
  if (!token) {
    return
  }

  try {
    const decodedToken = jwt.decode(token) as { id: string }
    window.Intercom('update', { user_id: decodedToken.id })

    window.intercomSettings = {
      ...(window.intercomSettings || {}),
      user_id: decodedToken.id,
    }
  } catch (err) {
    // Do nothing. what are you gunna do?
  }
}

export const updateIntercom = (data: any) => {
  window.intercomSettings = {
    ...(window.intercomSettings || {}),
    ...data,
  }

  if (!window.Intercom) {
    return
  }

  try {
    window.Intercom('update', data)
  } catch (err) {
    // Do nothing. what are you gunna do?
  }
}
